/* WINGBABE · accordion · vanilla JS, no dependencies */
(function(){
document.querySelectorAll('[data-accordion]').forEach(function(a){var t=a.querySelector('[data-accordion-trigger]'),p=a.querySelector('[data-accordion-panel]'),ic=a.querySelector('[data-accordion-icon]');if(!t||!p)return;
 function isOpen(){return getComputedStyle(p).display!=='none';}
 t.setAttribute('aria-expanded',isOpen()?'true':'false');
 t.addEventListener('click',function(){var o=!isOpen();p.style.display=o?'block':'none';t.setAttribute('aria-expanded',o?'true':'false');a.classList.toggle('is-open',o);if(ic)ic.textContent=o?'\u2212':'+';});});
})();
